export default __webpack_public_path__ + "static/blue-path-29af972c502749cc4202b0ada2eb9af9.png";